import { Injectable } from '@angular/core';
import { LoginData } from './login/logindata'
import { MenuItem } from 'primeng/primeng';
import { TokenCredentials } from './login/tokencredentials';

@Injectable()
export class SharedDataService {

  public loginData: LoginData;
  public testVariable = "Test!23";

  private mainMenuItems: MenuItem[];

  constructor() {
    this.loginData = { credentials: { username: "", userId: 0, token: "" }, isLoggedIn: false };
    this.mainMenuItems = [];

    console.log("Try to load data from session.");
    let loginData = sessionStorage.getItem('pl-logindata');
    if (loginData != null) {
      this.loginData = JSON.parse(loginData);
    }

    console.log("Is menue stored?");
    let mainMenuItems = sessionStorage.getItem('pl-mainmenuitems');
    if (mainMenuItems != null && this.loginData.isLoggedIn) {
      this.mainMenuItems = JSON.parse(mainMenuItems);
    }
  }

  public getMainMenuItems() : MenuItem[]
  {
    return this.mainMenuItems;
  }

  public setMainMenuItems(mainMenuItems : MenuItem[])
  {
    this.mainMenuItems = mainMenuItems;
    sessionStorage.setItem('pl-mainmenuitems', JSON.stringify(this.mainMenuItems));
  }

  public setLoginData(loginData: LoginData) {
    this.loginData = loginData;
    sessionStorage.setItem('pl-logindata', JSON.stringify(this.loginData));
    console.log('Login data is stored in session.');
  }

  public getLoginData() : LoginData 
  {
    return this.loginData;
  }

  public getTokenAuthData(): TokenCredentials {
    return this.loginData.credentials;
  }
}



// WEBPACK FOOTER //
// /home/pneuser/workspace/pepelogistic/pepeLogisticControl/src/app/shared-data.service.ts